export enum enPaymentType {
  FREE = 'G',
  NORMAL = 'N',
  SUBSCRIPTION = 'A',
  ECOMMERCE = ' ',
  DONATION = 'L'
}
